import {Navigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import GameDetail from "../components/GameDetail";
import {useSeo} from "../hooks/useMetadata";
import {fetchGameData} from "../config";
import GoftinoWidget from "../components/GoftinoWidget";
import {LEGACY_TO_NEW_GAME_SLUG} from "../utils/gameRoutes";

export default function Game() {
    const {game_id} = useParams();
    const [game, setGame] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!game_id) return;
        // Legacy URLs redirect via <Navigate/> below; skip fetching for them.
        if (LEGACY_TO_NEW_GAME_SLUG[game_id]) return;

        const loadGameData = async () => {
            try {
                setLoading(true);
                setError(null);

                // Canonical URLs end with "2" (e.g. menchbaz2) but the API
                // stores games under legacy slugs (e.g. menchbaz).
                // Try the id as-is, then fall back to the stripped form.
                let data;
                try {
                    data = await fetchGameData({"game_id": game_id});
                } catch (firstErr) {
                    if (game_id && game_id.endsWith("2") && game_id.length > 1) {
                        data = await fetchGameData({"game_id": game_id.slice(0, -1)});
                    } else {
                        throw firstErr;
                    }
                }
                setGame(data);

            } catch (error) {
                console.error('Error loading game data:', error);
                setError('Failed to load game data');
            } finally {
                setLoading(false);
            }
        };

        loadGameData();
    }, [game_id]);

    useSeo(
        game ? `استودیو بازیسازی مدریک: ${game.name}` : "استودیو بازیسازی مدریک",
        game ? `به استودیوی بازیسازی مدریک خوش آمدید. درباره بازی ${game.name} بیشتر بدانید.` : "به استودیوی بازیسازی مدریک خوش آمدید.",
        {keywords: game ? `medrick, game studio, mobile game, ${game.name}` : "medrick, game studio, mobile game"}
    );

    // Redirect legacy URLs (e.g. /games/menchbaz) to canonical URLs with
    // trailing "2". Done in React (react-router), not in nginx.
    if (game_id && LEGACY_TO_NEW_GAME_SLUG[game_id]) {
        return <Navigate to={`/games/${LEGACY_TO_NEW_GAME_SLUG[game_id]}`} replace/>;
    }

    if (loading) {
        return (
            <>
                <Header title=" بی‌خیالش ! بازی کن"/>
                <div className="loading">در حال بارگذاری...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Header title=" بی‌خیالش ! بازی کن"/>
                <div className="error">{error}</div>
            </>
        );
    }

    if (!game) {
        return (
            <>
                <Header title=" بی‌خیالش ! بازی کن"/>
                <div className="error">بازی یافت نشد</div>
            </>
        );
    }

    return (
        <>
            <Header title=" بی‌خیالش ! بازی کن"/>
            <GoftinoWidget widget_id={game.goftino_widget_id}/>
            <GameDetail game={game}/>
        </>
    );
}
